module.exports = __webpack_public_path__ + "static/media/5.3fd8eb4d.png";